var map = {
	"./garden1.jpg": 6442,
	"./garden2.jpg": 5538,
	"./garden3.jpg": 9254,
	"./garden4.jpg": 3065,
	"./garden5.jpg": 1074,
	"./garden6.jpg": 5754,
	"./garden7.jpg": 7814,
	"./garden8.jpg": 6368,
	"assets/photo/products/the-secret-garden/garden1.jpg": 6442,
	"assets/photo/products/the-secret-garden/garden2.jpg": 5538,
	"assets/photo/products/the-secret-garden/garden3.jpg": 9254,
	"assets/photo/products/the-secret-garden/garden4.jpg": 3065,
	"assets/photo/products/the-secret-garden/garden5.jpg": 1074,
	"assets/photo/products/the-secret-garden/garden6.jpg": 5754,
	"assets/photo/products/the-secret-garden/garden7.jpg": 7814,
	"assets/photo/products/the-secret-garden/garden8.jpg": 6368
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5390;